/* The InAppDetector is from "https://github.com/f2etw/detect-inapp" and uses MIT License. */

function InAppDetector(userAgent) {
    this.ua = userAgent;
}

InAppDetector.prototype.InAppBrowser = {
    messenger: /\bFB[\w_]+\/(Messenger|MESSENGER)/,
    facebook: /\bFB[\w_]+\//,
    line: /\bLine\//i
};

InAppDetector.prototype.isInApp = function () {
    var rules = ['WebView', '(iPhone|iPod|iPad)(?!.*Safari\/)', 'Android.*(wv)'];
    var regex = new RegExp("(".concat(rules.join('|'), ")"), 'ig');
    return Boolean(this.ua.match(regex));
};

InAppDetector.prototype.findKey = function (object, predicate) {
    var result;

    if (object === null) {
        return result;
    }

    Object.keys(object).some(function (key) {
        var value = object[key];
        if (predicate(value, key, object)) {
            result = key;
            return true;
        }
    });

    return result;
};

InAppDetector.prototype.getAppName = function () {
    return this.findKey(
        this.InAppBrowser,
        function (regex) {
            return regex.test(navigator.userAgent || navigator.vender || window.opera);
        }
    ) || 'none';
};

InAppDetector.prototype.isInSpecificApp = function () {
    var appName = this.getAppName();
    return this.isInApp() && (appName === 'messenger' || appName === 'facebook' || appName === 'line');
};

// Add by TWCA for exposing to window.
window.InAppDetector = InAppDetector;
